import { render, staticRenderFns } from "./noticeStyle.vue?vue&type=template&id=32bd0697&scoped=true"
import script from "./noticeStyle.vue?vue&type=script&lang=js"
export * from "./noticeStyle.vue?vue&type=script&lang=js"
import style0 from "./noticeStyle.vue?vue&type=style&index=0&id=32bd0697&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32bd0697",
  null
  
)

export default component.exports